import { resolvePaymentCapabilities } from '@cpce/shared';
import { CalendarClock } from 'lucide-react';
import { useMemo, useState } from 'react';
import type { PrestationTransactionFormatted } from '@/api/prestation-transactions/prestation-transactions.types';
import { Badge, BadgeColor } from '@/components/Badge';
import { toPaymentScheduleView } from '../utils/payment-schedule.utils';
import { PaymentScheduleDetailModal } from './PaymentScheduleDetailModal';

interface PaymentScheduleBadgeProps {
  transaction: PrestationTransactionFormatted;
}

export function PaymentScheduleBadge(props: PaymentScheduleBadgeProps) {
  const { transaction } = props;
  const [isOpen, setOpen] = useState(false);

  const schedule = useMemo(() => {
    const [payment] = transaction.payments;
    return toPaymentScheduleView(
      transaction,
      !!payment &&
        resolvePaymentCapabilities(payment.paymentMethodPreset, payment.financialAccount)
          .hasInstrumentNumber
    );
  }, [transaction]);

  if (!schedule) return null;

  return (
    <>
      <Badge asChild color={BadgeColor.BLUE} className="cursor-pointer hover:bg-blue-100">
        <button type="button" onClick={() => setOpen(true)} title="Voir l'échéancier">
          <CalendarClock />
          Échéancier · {schedule.depositedCount}/{schedule.rows.length} remis
        </button>
      </Badge>
      {isOpen && (
        <PaymentScheduleDetailModal
          open
          onOpenChange={setOpen}
          rows={schedule.rows}
          hasInstrumentNumber={schedule.hasInstrumentNumber}
          recurrenceLabel={schedule.recurrenceLabel}
        />
      )}
    </>
  );
}
